$(document).ready(function () {
    $('#guest-checkout').on('click', function () {
		$.redirect('/koszyk', { action: 'address_step', continue_as_guest: 1 }, 'POST')
	})
});